export default __webpack_public_path__ + "static/media/fa75b6f7e10efd2bad22a1e4f1ccc0351600887028308.1fbefda2.webp";